import React, { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CLOTHESTYPE } from '../../../enums';
import { ClothingService, FireDepartmentService } from '../../../services';
import { useAppSelector } from '../../../store/hooks';
import { selectDepartment, selectIsAdmin, selectIsSuperAdmin } from '../../../store/reducers';
import type { FireDepartment } from '../../../types';
import { SimpleListItem } from '../../atoms';

export function Clothes(): React.JSX.Element {
  const navigate = useNavigate();
  const department = useAppSelector(selectDepartment);
  const isAdmin = useAppSelector(selectIsAdmin);
  const isSuperAdmin = useAppSelector(selectIsSuperAdmin);

  const [isLoading, setIsLoading] = React.useState(true);
  const [clothing, setClothing] = React.useState<{ id: string; code: string; type: CLOTHESTYPE; name: string }[]>([]);
  const [departments, setDepartments] = React.useState<FireDepartment[]>([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState<string>('undefined');

  const loadClothing = async (): Promise<void> => {
    if (department || selectedDepartment !== 'undefined') {
      const clothingResponse = await ClothingService.getAllFireDepartmentClothes(
        department ? department.id : selectedDepartment
      );
      if (clothingResponse.error) {
        toast.error('Fehler beim Laden der Kleidung 😩');
        console.log(clothingResponse.message);

        return;
      }
      setClothing(clothingResponse.data as { id: string; code: string; type: CLOTHESTYPE; name: string }[]);
      setIsLoading(false);
    }
  };

  const loadFireDepartments = async (): Promise<void> => {
    const fireDepartmentResponse = await FireDepartmentService.getAllFireDepartments();
    if (fireDepartmentResponse.error) {
      toast.error('Fehler beim Laden der Feuerwehren 😩');
      console.log(fireDepartmentResponse.message);

      return;
    }
    setDepartments(fireDepartmentResponse.data as FireDepartment[]);
    setIsLoading(false);
  };

  const getClothingTypeName = (type: CLOTHESTYPE): string => {
    if (type === CLOTHESTYPE.JACKE) {
      return 'Jacke';
    }
    if (type === CLOTHESTYPE.AGT_HOSE) {
      return 'AGT-Hose';
    }
    if (type === CLOTHESTYPE.BUNDHOSE) {
      return 'Bundhose';
    }
    if (type === CLOTHESTYPE.LATZHOSE) {
      return 'Latzhose';
    }

    return 'XXXXXXX';
  };

  const handleAddButton = () => {
    navigate('add');
  };

  useEffect(() => {
    if (isSuperAdmin) {
      loadFireDepartments().then(() => {});
    } else {
      loadClothing().then(() => {});
    }
  }, []);

  useEffect(() => {
    if (selectedDepartment !== 'undefined') {
      loadClothing().then(() => {});
    }
    if (selectedDepartment === 'undefined') {
      setClothing([]);
    }
  }, [selectedDepartment]);

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={'container mt-10'}>
      {(isAdmin || isSuperAdmin) && (
        <div className='row mb-3'>
          <div className='col-12 d-flex justify-content-end'>
            <Button variant='success' onClick={handleAddButton}>
              Hinzufügen
            </Button>
          </div>
        </div>
      )}
      {isSuperAdmin && departments && (
        <div className='row mb-3'>
          <div className='col-12'>
            <Form.Select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value as string)}>
              <option value='undefined'>Abteilung auswählen</option>
              {departments.map((fd) => (
                <option value={fd.id}>{fd.name}</option>
              ))}
            </Form.Select>
          </div>
        </div>
      )}
      <div className='row'>
        {clothing.map((clothingItem) => (
          <div className='col-12 mb-2' key={`container-${clothingItem.id}`}>
            <SimpleListItem key={clothingItem.id} link={`/kleidung/${clothingItem.id}`}>
              {getClothingTypeName(clothingItem.type)} - {clothingItem.name} ({clothingItem.code})
            </SimpleListItem>
          </div>
        ))}
      </div>
    </div>
  );
}
